import AbandonedRequests from '../../server/abandoned';
import { addLoading, removeLoading } from './loading';

export const setAbandonedItems = ({ cartsAbandoned, userWithQuotation, userWithoutPurchase }) => ({
  type: 'GET_ABANDONED_ITEMS',
  cartsAbandoned,
  userWithQuotation,
  userWithoutPurchase,
});

export const getAbandonedItem = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    const place = await AbandonedRequests.getPlace(id);
    dispatch(setAbandonedItems(place));
  } finally {
    dispatch(removeLoading());
  }
};

export const getAbandonedItems = (initialDate, finalDate) => async (dispatch) => {
  dispatch(addLoading());
  try {
    const abandoned = await AbandonedRequests.getAbandonedItems(initialDate, finalDate);
    dispatch(setAbandonedItems(abandoned));
  } finally {
    dispatch(removeLoading());
  }
};

export const sendEmail = (userId, type, clientId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AbandonedRequests.sendEmail(userId, type, clientId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvAbandonedReport = (initialDate, finalDate, combinedData, isFiltered) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await AbandonedRequests.getCsvAbandonedReport(initialDate, finalDate, combinedData, isFiltered);
  } finally {
    dispatch(removeLoading());
  }
};
